import { toLower } from 'lodash-es'

export const normalizePhenomenon = (phenomenon) => {
    const {
        x_offset,
        phenomenon_uuid,
        sector_id,
        ...rest
    } = phenomenon

    return {
        id: toLower(phenomenon_uuid),
        xOffset: x_offset,
        sectorId: sector_id,
        ...rest
    }
}

export const normalizePhenomenonInput = (phenomenonInput) => {
    const {
        id,
        sectorId,
        time,
        xOffset,
        radarId,
        version,
        timing
    } = phenomenonInput

    return {
        radar_id: Number(radarId),
        phenomenon_uuid: id,
        sector_id: sectorId,
        time: parseFloat(time.toFixed(4)),
        x_offset: parseFloat(xOffset.toFixed(4)),
        version,
        timing
    }
}
